// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
function omitSpecialChars(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '');
}

export { omitSpecialChars };
